module.exports = __webpack_public_path__ + "static/media/wi-day-sunny.4b9869a6.svg";